module.exports = __webpack_public_path__ + "img/home-bg1.298c2575.jpg";